import { OLHostFamilyPricePerNight } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { OLHostFamilyPricePerNightInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night-input'
import { IdInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createOlHostFamilyPrice = async (data: IdInput<OLHostFamilyPricePerNightInput>) => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.createOlHostFamilyPrice.url, { olId: id }))
    .post<OLHostFamilyPricePerNight, OLHostFamilyPricePerNightInput>(rest)
}
